export default __webpack_public_path__ + "static/media/Share.781950e8.svg";